module.exports = __webpack_public_path__ + "img/sys1.496fa756.png";